export const industriesData = [
    {
        id: 'media-sport-broadcast',
        name: "Media, Sport & Broadcast",
        icon: (
            <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <polygon points="23 7 16 12 23 17 23 7"/>
                <rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
            </svg>
        ),
        description: "Emotionally adaptive content delivery that responds to audience engagement in real-time, transforming how stories are told and experienced.",
        outcomes: ["Real-time engagement", "Emotional storytelling", "Personalized experiences"]
    },
    {
        id: 'education',
        name: "Education",
        icon: (
            <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
                <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
            </svg>
        ),
        description: "Learning experiences that adapt to each student's emotional state and comprehension level, making education truly personalized.",
        outcomes: ["Adaptive learning", "Emotional awareness", "Student engagement"]
    },
    {
        id: 'fashion-luxury',
        name: "Fashion & Luxury",
        icon: (
            <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
                <line x1="7" y1="7" x2="7.01" y2="7"/>
            </svg>
        ),
        description: "Emotional connections between brands and customers, delivering experiences that resonate with individual style and aspirations.",
        outcomes: ["Brand emotional bond", "Personalized discovery", "Luxury experiences"]
    },
    {
        id: 'insurance-financial',
        name: "Insurance & Financial Services",
        icon: (
            <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <line x1="12" y1="1" x2="12" y2="23"/>
                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
            </svg>
        ),
        description: "Trust-building communication that understands customer anxiety and confidence, delivering the right message at the right emotional moment.",
        outcomes: ["Trust building", "Emotional clarity", "Customer confidence"]
    }
];
